export default __webpack_public_path__ + "95b92b4662e5fa14dbba563885193616.png";